import React from 'react';
import Actions from './Action/TemplateContinueActions';
import CircledCheckImage from '../../components/CircledCheckImage';
import CompanyIcon from '../../components/CompanyIcon';
import { TemplateContinue } from '../../components/TemplateContinue';
/**
 * This component is used to show a screen where there will be a an
 * image, title, subtitle, and continue button. It is specific to Link API.
 */
export function TemplateContinueLinkApi(_a) {
    var linkApiResponse = _a.linkApiResponse, onSubmit = _a.onSubmit;
    var renderedImage = linkApiResponse.template.imageUrl ? (React.createElement(CompanyIcon, { size: "lg", result: {
            logoUrl: linkApiResponse.template.imageUrl,
        } })) : (React.createElement(CircledCheckImage, null));
    var actionButtons = (React.createElement(Actions, { actions: linkApiResponse.template.actions, onSubmit: onSubmit }));
    return (React.createElement(TemplateContinue, { title: linkApiResponse.template.title, subtitle: linkApiResponse.template.subtitle, textList: linkApiResponse.template.textList, dataTestId: "TemplateContinue", Image: function () { return renderedImage; }, actions: actionButtons }));
}
export default TemplateContinueLinkApi;
